import React from "react";

export function SaveIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className="st0" d="M502.395,106.098L396.296,0h-15.162v121.49H130.866V0H60.271C26.987,0,0,26.987,0,60.271v391.458,C0,485.013,26.987,512,60.271,512h391.458C485.014,512,512,485.013,512,451.729V129.286,C512,120.591,508.542,112.256,502.395,106.098z M120.811,446.532H63.029v-55.122h57.782V446.532z" />
            <rect x="282.012" className="st0" width="68.027" height="94.015"></rect>
        </svg>
    );
}
